// import React from "react";
// import MobileHeader from "./MobileHeader";
// import { useNavigate } from "react-router-dom";

// function Header() {
//   const navigate = useNavigate();
//   return (
//     <div className="header">
//       <div className="nav2">
//         <div className="d-flex align-items-center">
//           <div>
//             <img
//               onClick={() => navigate("/")}
//               style={{
//                 cursor: "pointer",
//                 margin: "0px 5px",
//                 borderRadius: "10px",
//               }}
//               src="/asessts/Images/TaxiwithLocation1white.png"
//               className="goody-icon"
//               alt=""
//             />
//           </div>
//           <div>
//             <h5 style={{ color: "#10b981" }}>DriveOme</h5>
//           </div>
//         </div>

//         <div>
//           <ul>
//             {/* <li>HOME</li>
//             <li>OUR STORY</li>
//             <li>DELIVER GOODS</li>
//             <li>DRIVERS PARTNERS</li>
//             <li>CONTACT US</li> */}
//           </ul>
//         </div>
//       </div>
//       <div className="mobile">
//         <MobileHeader />
//       </div>
//     </div>
//   );
// }

// export default Header;

import React from "react";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  return (
    <div className="header">
      <div className="nav-container">
        <div className="logo-container" onClick={() => navigate("/")}>
          <img
            src="/asessts/Images/TaxiwithLocation1white.png"
            className="logo"
            alt="DriveOme Logo"
          />
          <h5 className="brand-name">DriveOme</h5>
        </div>

        <div className="navigation-links">
          <ul>
            <li>
              <Link to="/">HOME</Link>
            </li>
            <li>
              <Link to="/local">LOCAL</Link>
            </li>
            <li>
              <Link to="/outstation">OUTSTATION</Link>
            </li>
            {/* <li>
              <Link to="/drivingschool">DRIVING SCHOOL</Link>
            </li>
            <li>
              <Link to="/hiredriver">HIRE DRIVER</Link>
            </li>
            <li>
              <Link to="/rentalbike">RENTAL BIKE</Link>
            </li> */}
            <li>
              <Link to="/packersandmovers">PACKERS & MOVERS</Link>
            </li>
          </ul>
        </div>

        <div className="header-actions">
          <button
            className="action-button"
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.DriveOme.com",
                "_blank"
              )
            }
          >
            <i className="fas fa-download"></i> Get App
          </button>
        </div>
      </div>

      <div className="mobile-header">
        <div className="mobile-nav">
          <div className="mobile-logo-container" onClick={() => navigate("/")}>
            <img
              src="/asessts/Images/TaxiwithLocation1white.png"
              className="mobile-logo"
              alt="DriveOme Logo"
            />
            <h5 className="mobile-brand-name">DriveOme</h5>
          </div>
          <div className="hamburger-menu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <style jsx>{`
        .header {
          background-color: #000;
          color: white;
          padding: 12px 40px;
          font-family: "Poppins", sans-serif;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          position: sticky;
          top: 0;
          z-index: 1000;
        }

        .nav-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo-container {
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .logo {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          margin-right: 10px;
        }

        .brand-name {
          color: #10b981;
          margin: 0;
          font-size: 22px;
          font-weight: 600;
        }

        .navigation-links ul {
          display: flex;
          list-style: none;
          margin: 0;
          padding: 0;
          gap: 25px;
        }

        .navigation-links li {
          font-weight: 500;
          font-size: 14px;
          transition: color 0.3s;
        }

        .navigation-links a {
          color: white;
          text-decoration: none;
          transition: color 0.3s;
        }

        .navigation-links a:hover {
          color: #10b981;
        }

        .header-actions {
          display: flex;
          align-items: center;
        }

        .action-button {
          background-color: #10b981;
          color: #000;
          border: none;
          padding: 10px 20px;
          border-radius: 20px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .action-button:hover {
          background-color: #10b981;
          transform: translateY(-2px);
        }

        .mobile-header {
          display: none;
        }

        @media (max-width: 768px) {
          .header {
            padding: 10px 20px;
          }

          .nav-container {
            display: none;
          }

          .mobile-header {
            display: block;
          }

          .mobile-nav {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .mobile-logo-container {
            display: flex;
            align-items: center;
            gap: 10px;
            cursor: pointer;
          }

          .mobile-logo {
            width: 35px;
            height: 35px;
            border-radius: 8px;
          }

          .mobile-brand-name {
            color: #10b981;
            margin: 0;
            font-size: 18px;
          }

          .hamburger-menu {
            display: flex;
            flex-direction: column;
            gap: 4px;
            cursor: pointer;
          }

          .hamburger-menu span {
            width: 25px;
            height: 3px;
            background-color: white;
          }
        }
      `}</style>
    </div>
  );
}

export default Header;
